import React from 'react';
// Components
import VideoEditingRequestsTable from './VideoEditingRequestsTable/VideoEditingRequestsTable';

const VideoEditingRequests: React.FC = () => {
  return <VideoEditingRequestsTable />;
};

export default VideoEditingRequests;
